import type { ReactNode } from 'react';
import { RouteBg } from './phone/RouteBg';
import './homepage.css';

type BgVariant = 'paper' | 'paper-2' | 'sand' | 'navy' | 'ink';
type Props = {
  id?: string;
  bg?: BgVariant;
  route?: boolean;
  routeSeed?: number;
  tight?: boolean;
  wide?: boolean;
  children: ReactNode;
};

const BG_VARS: Record<BgVariant, string> = {
  paper: 'var(--paper)',
  'paper-2': 'var(--paper-2)',
  sand: 'var(--sand)',
  navy: 'var(--navy)',
  ink: 'var(--ink)',
};

export function Section({
  id,
  bg = 'paper',
  route = false,
  routeSeed = 0,
  tight = false,
  wide = false,
  children,
}: Props) {
  const isDark = bg === 'ink' || bg === 'navy';
  return (
    <section
      id={id}
      data-screen-label={id}
      className={`section${tight ? ' section-tight' : ''}`}
      style={{ background: BG_VARS[bg], color: isDark ? 'var(--paper)' : 'var(--ink)' }}
    >
      {route && <RouteBg seed={routeSeed} />}
      <div className={wide ? 'wrap wrap-wide' : 'wrap'}>{children}</div>
    </section>
  );
}
